import { TerminalDtoToEntity } from "src/app/features/Terminal/services/mappers/TerminalDtoToEntity";
import type { TerminalDto } from "src/app/features/Terminal/types/TerminalDto";
import type { TerminalEntity } from "src/app/features/Terminal/types/TerminalEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const TerminalTableDtoMapper = (input: Readonly<ResourcePageDto<TerminalDto>>): ResourcePageEntity<TerminalEntity> => {
    return {
        list: input.list ? input.list.map(TerminalDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
